export const FIDELIDADE_MAPA_SET_CLIENTES = "FIDELIDADE_MAPA_SET_CLIENTES";
export const FIDELIDADE_MAPA_LOADING = "FIDELIDADE_MAPA_LOADING";
export const FIDELIDADE_MAPA_SET_LOCALIZACAO_EMPRESA =
  "FIDELIDADE_MAPA_LOCALIZACAO_EMPRESA";
